import { Button, Text, useDisclosure, ButtonProps } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AiOutlinePlusCircle } from 'react-icons/ai';
import DynamicPageModal from '../DynamicPageModal';

type CreatePageButtonProps = ButtonProps;

const CreatePageButton: FC<CreatePageButtonProps> = ({ ...rest }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { t } = useTranslation();

  return (
    <>
      <DynamicPageModal isOpen={isOpen} onClose={onClose} />
      <Button
        display="flex"
        alignItems="center"
        size="md"
        variant="outline"
        colorScheme="cyan"
        {...rest}
        onClick={() => onOpen()}
      >
        <AiOutlinePlusCircle />
        <Text ml="1.5">{t('newPage')}</Text>
      </Button>
    </>
  );
};

export default CreatePageButton;
